import { useState } from "react";
import { Header } from "../../components/Header";
import { ScrollProps } from "../../components/AdvancedSearch";
import { Container } from "../PropertyDetailsShare/styles";
import { MdConstruction } from "react-icons/md";
import { Content } from "./styles";
import { Footer } from "../../components/Footer";

export function EmDesenvolvimento() {

    const [scrollTop, setScrollTop] = useState<ScrollProps>({ y: 0, lastY: 0 } as ScrollProps);
    const [show, setShow] = useState(false);
    const [search, setSearch] = useState('');

    const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
        const scrollTop = event.currentTarget.scrollTop;
        setScrollTop(prevState => { return { y: scrollTop, lastY: prevState.y } })
    }


    return (
        <Container onScroll={handleScroll} show={show}>
            <Header show={show} setShow={setShow} scroll={scrollTop} search={search} setSearch={setSearch} />

            <Content>
                <h1>Página em desenvolvimento</h1>
                <MdConstruction />
                <p>
                    Para mais informações, contate-nos via nossa <a href="/ouvidoria">ouvidoria</a>.
                </p>
            </Content>
            <Footer />
        </Container>
    );
}